import { Plus } from '@carboledger/ui/icons';
import emptyBoxIllustration from '@/assets/illustrations/empty-box.png';

// Each drill-down tab's empty card. Copy and CTAs come from the owning slice's own keys.

const illustration = <img src={emptyBoxIllustration} alt="" width={200} height={200} />;
const addIcon = <Plus />;

/**
 * The card a tab shows when it holds nothing at all — Figma gives each one its own copy and
 * an Add action that leaves Inventory for the slice owning the record.
 */
// TODO: add Figma's Import CTA once the shared .xlsx wizard exists; EmptyState cannot disable one.
export const buildTabEmptyState = (t, { titleKey, descriptionKey, addKey, onAdd }) => ({
  image: illustration,
  title: t(titleKey),
  description: t(descriptionKey),
  ...(addKey ? { primaryLabel: t(addKey), onPrimaryClick: onAdd, primaryIcon: addIcon } : {}),
});

/** The card shown when a search or filter matched nothing — never carries a CTA. */
export const buildTabNoResults = (t, titleKey) => ({
  image: illustration,
  title: t(titleKey),
  description: t('COMMON_NO_RESULTS_DESCRIPTION'),
});

// A Summary report with nothing at all — Figma gives each of the three its own copy.
export const buildSummaryEmptyState = (t, { titleKey, descriptionKey }) => ({
  image: illustration,
  title: t(titleKey),
  description: t(descriptionKey),
});

// A Summary report whose date range or filters matched nothing.
export const buildSummaryNoResults = (t) => ({
  image: illustration,
  title: t('INVENTORY_SUMMARY_NO_RESULTS_TITLE'),
  description: t('INVENTORY_SUMMARY_NO_RESULTS_DESCRIPTION'),
});
